<script lang="ts">
  import type { SwiperOptions } from 'swiper/types';
  import { isMobileWidth } from '../../../common/util';
  import RmnBannerWithProductList from '../../common/components/RmnBannerWithProductList.svelte';
  import PictureTag from '../../common/lazy-components/PictureTag.svelte';
  import { normalizeBanner, normalizeBannerGroup } from '../../common/services/banner-utils';
  import ExtraRMNCarousalTemplate from './ExtraRMNCarousalTemplate.svelte';
  import ExtraSwiper from './ExtraSwiper.svelte';
  import Text from './Text.svelte';

  export let banner;
  export let metaData = { displayBanners: [] };
  const isResponsive = isMobileWidth();

  function getSwiperOptions(slides, space): SwiperOptions {
    return {
      slidesPerView: slides,
      spaceBetween: space,
      navigation: !isResponsive,
    };
  }

  const bannerCardSwiperOptions = getSwiperOptions('auto', 8);

  $: bannerGroup = normalizeBannerGroup(metaData, banner);

  $: console.log('bannerGroup', bannerGroup);

  $: type = bannerGroup?.type;

  $: nativeBanners = type === 'NATIVE_BANNER' ? bannerGroup?.banners : [];

  $: sponsoredBanner =
    type === 'SPONSORED_BRAND_VIDEO' || type === 'SPONSORED_BRAND_IMAGE'
      ? normalizeBanner(bannerGroup?.banners?.[0])
      : null;

  $: singleBanner = nativeBanners?.length === 1 ? normalizeBanner(nativeBanners[0]) : null;
</script>

<section class="rmn-inline-banner-container">
  {#if (type === 'NATIVE_BANNER' && singleBanner) || type === 'SPONSORED_BRAND_VIDEO' || type === 'SPONSORED_BRAND_IMAGE'}
    <div class="rmn-sponsored-title">
      <Text key="extra.sponsored.text" />
    </div>
  {/if}
  <!-- SINGLE NATIVE BANNER -->
  {#if singleBanner}
    <a href={singleBanner.redirectUrl} class="rmn-inline-banner">
      <PictureTag image={singleBanner.imageUrl} width="100%" height="auto" alt="banner" />
    </a>
  {/if}

  <!-- MULTIPLE NATIVE → CAROUSEL -->
  {#if nativeBanners.length > 1}
    <div class="banner-card-scroll">
      <ExtraSwiper
        slidesData={nativeBanners}
        slideTemplate={ExtraRMNCarousalTemplate}
        swiperOptions={bannerCardSwiperOptions}
      />
    </div>
  {/if}

  <!--  SPONSORED BANNER -->
  {#if sponsoredBanner}
    <div class="rmn-inline-banner sponsored-banner">
      <RmnBannerWithProductList bannerData={sponsoredBanner} isGridView={false} />
    </div>
  {/if}
</section>

<style lang="scss">
  @import '../styles/colors.new.scss';

  .rmn-inline-banner-container {
    padding: 40px 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
    @include desktop-max-width {
      justify-content: flex-end;
      padding: 16px;
    }
    .rmn-sponsored-title {
      font-weight: 500;
      font-size: 16px;
      line-height: 12px;
      text-transform: capitalize;
      color: $primary-blue;
    }
    .rmn-inline-banner {
      display: block;
    }

    .html-banner {
      width: 100%;
    }

    .video-banner {
      video {
        width: 100%;
        border-radius: 8px;
      }
    }
    min-width: 250px;
  }
</style>
